import React, { useCallback, useEffect, useMemo } from 'react';
import { StepErrorTemplate } from '../steps-contents';
import { clearLocalStorage } from '../state';
import {
  SegmentEventType,
  useSegmentContext,
} from '../features/segment-context';
import {
  ElementWrapperTemplate,
  FooterTemplate,
  HeaderTemplate,
  MainTemplate,
  MainTemplateProps,
  ProgressTemplate,
} from './templates';

function ErrorProgress() {
  return <ProgressTemplate progress={0} />;
}

function ErrorElementGenerator(error?: string) {
  return function ErrorElement() {
    const onClick = useCallback(() => {
      clearLocalStorage();
      window.location.reload();
    }, []);

    return <StepErrorTemplate error={error} onClick={onClick} />;
  };
}

function ErrorContentGenerator(error?: string) {
  return function ErrorElementWrapper() {
    const ElementComponent: MainTemplateProps['ContentComponent'] = useMemo(
      () => ErrorElementGenerator(error),
      [],
    );

    return (
      <ElementWrapperTemplate display ElementComponent={ElementComponent} />
    );
  };
}

export function Oops(props: { error?: string }) {
  const { error } = props;
  const { trackEvent } = useSegmentContext();

  const ErrorContent: MainTemplateProps['ContentComponent'] = useMemo(
    () => ErrorContentGenerator(error),
    [error],
  );

  useEffect(() => {
    if (error) {
      trackEvent(SegmentEventType.ERROR_MESSAGE_SHOWN, {
        step: 'unknown',
        errors: [error],
      });
    }
  }, [error, trackEvent]);

  return (
    <MainTemplate
      HeaderComponent={HeaderTemplate}
      ProgressComponent={ErrorProgress}
      ContentComponent={ErrorContent}
      FooterComponent={FooterTemplate}
    />
  );
}
